import { render, staticRenderFns } from "./studyData.vue?vue&type=template&id=c64d6948&scoped=true&"
import script from "./studyData.vue?vue&type=script&lang=js&"
export * from "./studyData.vue?vue&type=script&lang=js&"
import style0 from "./studyData.vue?vue&type=style&index=0&id=c64d6948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64d6948",
  null
  
)

export default component.exports